import * as Actions from '../actions'

const initialState = {
  place: undefined,
  teamMember: undefined,
}

export default function (state = initialState, action) {
  switch (action.type) {
    case Actions.SET_SUSPENDED_STATUS: {
      return action.payload
    }
    case Actions.CLEAR_SUSPENDED: {
      return initialState
    }
    default: {
      return state
    }
  }
}
